import { render, staticRenderFns } from "./suggested-games.vue?vue&type=template&id=c9def63e&"
import script from "./suggested-games.vue?vue&type=script&lang=js&"
export * from "./suggested-games.vue?vue&type=script&lang=js&"
import style0 from "./suggested-games.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports